module.exports = __webpack_public_path__ + "static/media/md.ad844664.svg";